//
// HCL Technologies Confidential
// (C) Copyright HCL Technologies 2026. All Rights Reserved.
// The source code for this program is not published or otherwise divested
// of its trade secrets, irrespective of what has been deposited with the
// U.S. Copyright Office.
//
import { getSafeToken } from './securityUtils';

/** The slice of the OIDC user a tenant-service client needs. */
export type AuthUserContext = () => { access_token?: string } | undefined;

/** Bearer-token JSON headers for the tenant service, shared by its client services. */
export const buildAuthHeaders = (
  getUserContext: AuthUserContext,
): { Authorization: string; 'Content-Type': string } => {
  const token = getSafeToken(getUserContext()?.access_token);
  return {
    Authorization: `Bearer ${token}`,
    'Content-Type': 'application/json',
  };
};
